import React, { useState, useEffect } from 'react';

import { auth } from '../../utils/firebase';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from 'firebase/auth';
import styles from './SignIn.module.scss';
import { useLocation } from 'react-router-dom';

import Main from '../../components/Main/Main';
import Heading from '../../components/Heading/Heading';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import Form from '../../components/Form/Form';
import Loading from '../../components/Loading/Loading';
import Section from '../../components/Section/Section';

const SignIn = () => {
  const location = useLocation();
  const preferedForm = location.hash.replace('#', '');

  const [form, setForm] = useState(preferedForm ? preferedForm : 'signIn');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [validEmail, setValidEmail] = useState(false);
  const [validPassword, setValidPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    location.hash = '';
  }, [location]);

  useEffect(() => {
    if (email.length >= 5) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  }, [email]);

  useEffect(() => {
    if (password.length >= 6) {
      setValidPassword(true);
    } else {
      setValidPassword(false);
    }
  }, [password]);

  useEffect(() => {
    setEmail('');
    setPassword('');
    setError('');
  }, [form]);

  const register = () => {
    setLoading(true);
    if (validEmail && validPassword) {
      createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          setError('');
        })
        .catch((error) => {
          const errorMessage = error.message;
          setError(errorMessage);
          setLoading(false);
        });
    }
  };

  const signIn = () => {
    setLoading(true);
    if (validEmail && validPassword) {
      signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          setError('');
        })
        .catch((error) => {
          const errorMessage = error.message;
          setError(errorMessage);
          setLoading(false);
        });
    }
  };

  const forgotPassword = () => {
    setLoading(true);
    if (validEmail) {
      sendPasswordResetEmail(auth, email)
        .then(() => {
          setLoading(false);
          setError('Password reset email has been sent');
        })
        .catch((error) => {
          setForm('signIn');
          setLoading(false);
          const errorMessage = error.message;
          setError(errorMessage);
        });
    }
  };

  return (
    <Main>
      <Button secondary className={styles.back} link={'/'}>
        Back to frontpage
      </Button>
      {loading ? (
        <Loading />
      ) : (
        <Section>
          {error !== '' && <div className={styles.error}>{error}</div>}
          {form === 'register' && (
            <Form>
              <Heading>New account</Heading>
              <Input
                placeholder={'E-mail'}
                type={'email'}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <Input
                placeholder={'Password'}
                type={'password'}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <Button
                disabled={!validEmail || !validPassword}
                onClick={register}
              >
                Register
              </Button>
              <div className={styles.secondary}>
                <Button
                  secondary
                  onClick={() => {
                    setForm('signIn');
                  }}
                >
                  Allready have an account?
                </Button>
              </div>
            </Form>
          )}
          {form === 'signIn' && (
            <Form>
              <Heading>Existing account</Heading>
              <Input
                placeholder={'E-mail'}
                type={'email'}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <Input
                placeholder={'Password'}
                type={'password'}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <Button disabled={!validEmail || !validPassword} onClick={signIn}>
                Sign in
              </Button>
              <div className={styles.secondary}>
                <Button
                  secondary
                  onClick={() => {
                    setForm('reset');
                  }}
                >
                  Forgot your password?
                </Button>
                <Button
                  secondary
                  onClick={() => {
                    setForm('register');
                  }}
                >
                  Dont have an account?
                </Button>
              </div>
            </Form>
          )}
          {form === 'reset' && (
            <Form>
              <Heading>Reset password</Heading>
              <Input
                placeholder={'E-mail'}
                type={'email'}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <Button disabled={!validEmail} onClick={forgotPassword}>
                Resend
              </Button>
              <div className={styles.secondary}>
                <Button
                  secondary
                  onClick={() => {
                    setForm('signIn');
                  }}
                >
                  Back to login
                </Button>
              </div>
            </Form>
          )}
        </Section>
      )}
    </Main>
  );
};
export default SignIn;
